function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 35",
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 8835"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 8767"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3680",
    transform: "translate(46.288 41.77)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h4.711v1.919H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3681",
    transform: "translate(38.715 37.93)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h4.712v5.759H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3682",
    transform: "translate(31.144 34.09)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h4.712v9.599H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3683",
    transform: "translate(23.572 30.25)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h4.713v13.438H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 3684",
    style: {
      fill: "#fff"
    },
    d: "M0 0h4.712v20.379H0z",
    transform: "translate(16 23.31)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlack);
export default __webpack_public_path__ + "static/media/icon_black.2b13ca75ce077bc9a308d1f8d71ba005.svg";
export { ForwardRef as ReactComponent };